import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export type Lang = "en" | "fr";

export function useCurrentLang(): Lang {
  const location = useLocation();
  return useMemo(() => {
    if (location.pathname.startsWith("/fr") && (location.pathname === "/fr" || location.pathname.startsWith("/fr/"))) {
      return "fr";
    }
    return "en";
  }, [location.pathname]);
}

export function langFromPath(pathname: string): Lang {
  if (pathname.startsWith("/fr") && (pathname === "/fr" || pathname.startsWith("/fr/"))) {
    return "fr";
  }
  return "en";
}

export function getAltLangUrl(currentPath: string, search?: string, hash?: string): string {
  const isFr = langFromPath(currentPath) === "fr";
  const s = search ?? "";
  const h = hash ?? "";
  
  if (isFr) {
    // /fr/xxx → /xxx
    if (currentPath === "/fr") return "/" + s + h;
    return currentPath.replace(/^\/fr/, "") + s + h;
  } else {
    // /xxx → /fr/xxx
    if (currentPath === "/") return "/fr" + s + h;
    return "/fr" + currentPath + s + h;
  }
}